import { render, staticRenderFns } from "./OwnersRepeater.vue?vue&type=template&id=cd2fcec8&"
import script from "./OwnersRepeater.vue?vue&type=script&lang=js&"
export * from "./OwnersRepeater.vue?vue&type=script&lang=js&"
import style0 from "./OwnersRepeater.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports